import * as React from 'react';
import { Progress } from 'reactstrap';

type Props = {
  value: number;
  max?: number;
  successThreshold?: number;
  warningThreshold?: number;
};

export default class ScoreBar extends React.Component<Props> {
  render() {
    const {
      max = 100,
      successThreshold = 80,
      value,
      warningThreshold = 50,
    } = this.props;
    const percent = (value / max) * 100;
    let color;

    if (percent >= successThreshold) {
      color = 'success';
    } else if (percent >= warningThreshold) {
      color = 'warning';
    } else {
      color = 'danger';
    }

    return <Progress color={color} value={percent} />;
  }
}
